import global from "../utils/global.js"

export default class Transition {

	constructor( options = {} ) {

		this.enter = this.enter.bind( this )
		this.leave = this.leave.bind( this )
		this.config = {

			...options,
			enter: ( data ) => this.enter( data ),
			leave: ( data ) => this.leave( data )

		}
		global.transitions.push( this.config )
		return this.config

	}

	enter() {


	}

	leave() {


	}

}
